<template>
  <div key="video-panel"
       class="bg-black flex justify-center items-center">
    <!-- resolveVideoSource returns null for a Bunny video that is still
         encoding and for a topic with no video at all. Mounting video.js on
         either would show a player that can only error. -->
    <div v-if="!videoSource" role="status" aria-live="polite"
         class="video-unavailable text-white text-center p-6">
      {{ $t('general.video-not-ready') }}
    </div>
    <div v-else class="video-player">
      <video ref="videoPlayer" class="video-js" controls></video>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js';
import {resolveVideoSource} from "@/utils/video-source";

export default {
  name: "MainPanelVdo",
  props: [
    'currentVdoSetTopic',
  ],
  data() {
    return {
      player: null,
      isPlaying: false,
      counter: 0,
      timer: null,
    }
  },
  computed: {
    videoSource() {
      return resolveVideoSource(this.currentVdoSetTopic);
    },
  },
  watch: {
    // Watching the resolved source rather than the topic: the empty state and
    // the player are behind a v-if on exactly this value, so this is the
    // moment the <video> element appears or disappears.
    videoSource(source) {
      if (!source) {
        if (this.player) {
          this.player.dispose();
          this.player = null;
        }
        return;
      }
      if (this.player) {
        this.player.src(source);
        return;
      }
      // v-if has only just rendered <video>; $refs.videoPlayer does not exist
      // until the next tick.
      this.$nextTick(() => this.setUpVideoJs());
    },
  },
  methods: {
    setUpVideoJs() {
      // The videoSource watcher defers this to $nextTick, so two source
      // changes inside one flush can queue two calls before this.player is
      // assigned by the first.
      if (this.player) return;

      const _this = this;

      _this.player = videojs(this.$refs.videoPlayer, {
          sources: [this.videoSource],
          controlBar: {
            // playbackRateMenuButton: true,
            pictureInPictureToggle: false,
          },
          autoplay: true,
          fluid: false,
          controls: true,
          hotkeys: true,
          responsive: true,
          aspectRatio: '16:9',
          playbackRates: [1, 1.5, 2],
          preload: 'metadata',
          nativeControlsForTouch: true,
          nativeControls: true,

        },
        function onPlayerReady() {
          _this.$refs.videoPlayer.controls = true;
        },
      );

      // set playback rate for faster video playback
      _this.player.playbackRate(4);
    },
  },
  mounted() {
    // Without the videoSource check this runs against a $refs.videoPlayer that
    // v-if never rendered.
    if (!this.player && this.videoSource) {
      this.setUpVideoJs();
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="scss">

.video-player {
  width: 100% !important;
  height: auto !important;
  max-height: calc(100vh - 180px) !important;
  background: #22292f;
  overflow: hidden;
  position: relative;

  & .video-js {
    width: 100% !important;
    height: auto !important;
    padding-top: 0 !important;

    & video {
      width: 100% !important;
      height: auto !important;
      max-height: 100vh;
      @media only screen and (min-height: 600px) {
        max-height: calc(100vh - 200px);
      }
    }

    & .vjs-control-bar {
      display: none;
      z-index: 999999;
      position: absolute;
    }

    & .vjs-loading-spinner {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      // background: #0000005c;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      display: none;
    }

    & .vjs-big-play-button {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 200px;
      height: 200px;
      background: #0000005c;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      border-radius: 50%;
      border-width: 5px;
      border-color: #ffffff5e;
      display: none;
    }

    & .vjs-control-bar {
      display: none;
      position: absolute;
      bottom: 0;
      height: 40px;
      background: red;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      display: none;

      & > .vjs-control {
        margin: 10px;
      }

    }

    & .vjs-poster {
      display: none;
    }

    & .vjs-text-track-display {
      display: none;
    }

    & .vjs-error-display {
      display: none;
    }

    & .vjs-modal-dialog {
      display: none;
    }
  }
}
</style>
